export default __webpack_public_path__ + "static/undraw_analysis_4jis-ab43d6d49112b8f0ef216f9612b039d0.svg";